import { render, staticRenderFns } from "./addcargo.vue?vue&type=template&id=628f5ed4&scoped=true"
import script from "./addcargo.vue?vue&type=script&lang=js"
export * from "./addcargo.vue?vue&type=script&lang=js"
import style0 from "./addcargo.vue?vue&type=style&index=0&id=628f5ed4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628f5ed4",
  null
  
)

export default component.exports